import React from "react"
import { IconWrapper, IconPath } from "shared/Styles/Icons"
import { withTheme } from "styled-components"
import styled from "styled-components"

const StyledIconPath = styled(IconPath)`
    transform: translateY(0);
    animation: bounce ${props => props.time} ease-in infinite;
    @keyframes bounce {
        0% {
            transform: translateY(-2px);
        }
        50% {
            transform: translateY(2px);
        }
        100% {
            transform: translateY(-2px);
        }
    }
`

const Scroll = withTheme(({theme}) => (
  <IconWrapper
    width="22px"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    style={{overflow:"visible"}}
    viewBox="0 0 47.7 97"
    xmlSpace="preserve"
  >
    <g>
      <StyledIconPath
        time={"1.6s"}
        color={theme.color.white}
        d="M23.9,0C10.7,0,0,9,0,20.1v37.7c0,10.1,8.8,18.4,20.3,19.9v-2.5C10.2,73.9,2.5,66.6,2.5,57.9V20.1
            c0-9.7,9.6-17.7,21.4-17.7c11.8,0,21.4,7.9,21.4,17.7v37.7c0,9.4-8.9,17.1-20.2,17.6V37.4h-2.5v51.4v3.4l-4.3-4.3l-1.7,1.7l7.3,7.3
            l7.3-7.3l-1.7-1.7l-4.3,4.3V78c12.6-0.5,22.6-9.4,22.6-20.1V20.1C47.7,9,37,0,23.9,0z"
      ></StyledIconPath>
      <IconPath
        color={theme.color.white}
        d="M31.3,19.5c0-4.1-3.3-7.4-7.4-7.4c-4.1,0-7.5,3.3-7.5,7.4c0,4.1,3.3,7.5,7.5,7.5C28,27,31.3,23.6,31.3,19.5z
            M23.9,14.5c2.7,0,5,2.2,5,5c0,2.7-2.2,5-5,5c-2.7,0-5-2.2-5-5C18.9,16.8,21.1,14.5,23.9,14.5z"
      ></IconPath>
    </g>
  </IconWrapper>
))

export { Scroll }